<div class="payment-ledger-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container ledger-table-section">
    <article class="ledger-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">Transactions</p>
          <h2>Wholesaler payment activity</h2>
        </div>
        <span class="badge-counter">{{ totalItems || 0 }} records</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <thead>
            <tr>
              <th scope="col">S No.</th>
              <th scope="col">Wholesalers Name</th>
              <th scope="col">Order ID</th>
              <th scope="col">Date & Time</th>
              <th scope="col">Total Receive Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of paymentData
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems
                      };
                let i = index
              "
            >
              <td>{{ pageSize * (currentPage - 1) + i + 1 }}</td>
              <td class="customer-name">
                {{ item?.PaidToDetails?.[0]?.firstName || '--' }}
                {{ item?.PaidToDetails?.[0]?.lastName || '' }}
              </td>
              <td class="order-id">{{ item?.orderDetails?.orderId || '--' }}</td>
              <td>{{ item?.createdAt | date : 'yyyy-MM-dd h:mm:ss a' }}</td>
              <td class="amount-cell">
                {{
                  item?.orderAmount
                    ? getPrice(item?.orderAmount | currency : 'ZAR' : 'R')
                    : '--'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        *ngIf="paymentData?.length === 0 && !isLoading"
        class="empty-state text-center"
      >
        <p class="text-muted mb-3">
          No payouts yet. Once wholesalers receive funds, those records will be
          listed here.
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="bi bi-receipt"
          width="58"
          height="58"
          fill="lightgray"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27m.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0z"
          />
          <path
            d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h6a .5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5m8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5"
          />
        </svg>
      </div>

      <app-table-loader
        *ngIf="isLoading"
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="notFoundData"
        [colspan]="10"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="ledger-table-footer" *ngIf="totalItems > pageSize">
        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>